export default __webpack_public_path__ + "static/media/tryon-title-logo.db0af2d1.png";